import { BaseDocumentId, customNanoId } from "../base-document-id";
import type {
	DocumentGenerationVersion,
	DocumentHistoryVersion,
	DocumentUniqueId,
} from "../types";

export class ChatDocumentId extends BaseDocumentId {
	constructor(
		id?: DocumentUniqueId,
		generationVersion?: DocumentGenerationVersion,
		historyVersion?: DocumentHistoryVersion,
	) {
		super("chat", id ?? customNanoId(), generationVersion, historyVersion);
	}

	atGenerationVersion(generationVersion: DocumentGenerationVersion) {
		return new ChatDocumentId(this.id, generationVersion, this.historyVersion);
	}

	atHistoryVersion(historyVersion: DocumentHistoryVersion) {
		return new ChatDocumentId(this.id, this.generationVersion, historyVersion);
	}
}
